export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig().public
  const defaultCurrency = config.defaultCurrency
  const isMultiCurrency = config.features?.multiCurrency
  const currency = useCookie('currency')
  // For single-currency clients the visitor can never switch currency, so a
  // stale cookie from a previous default must not win over the configured one.
  if (!currency.value || !isMultiCurrency) {
    currency.value = defaultCurrency
  }
})
